export enum Country {
  USA = 'USA',
  CAN = 'CAN',
  MEX = 'MEX',
}

export interface CountryConfigItem {
  code: string
  // ISO-3166 alpha-3 code — the standardized value stored on addresses.
  code3: Country
  // Accepted spellings, lowercase. Anything not listed passes through
  // standardizeCountry unchanged.
  aliases: string[]
  label: string
  phoneCode: string
  phoneFormatPlaceholder: string
  ssnFormatPlaceholder: string
  ssnTitle: string
  abbreviation: string
  validation: {
    ssn: {
      value: RegExp
      message: string
    }
  }
}

export const CountryConfig: Record<string, CountryConfigItem> = {
  US: {
    code: 'US',
    code3: Country.USA,
    aliases: [
      'united states',
      'us',
      'usa',
      'u.s.',
      'u.s.a.',
      'united states of america',
    ],
    label: 'USA',
    phoneCode: '+1',
    phoneFormatPlaceholder: '(555) 555 - 5555',
    ssnFormatPlaceholder: '555-55-5555',
    ssnTitle: 'Social Security Number',
    abbreviation: 'SSN',
    validation: {
      ssn: {
        value: /^\d{9}$/,
        message: 'Invalid SSN',
      },
    },
  },
  CA: {
    code: 'CA',
    code3: Country.CAN,
    aliases: ['canada', 'can', 'ca'],
    label: 'Canada',
    phoneCode: '+1',
    phoneFormatPlaceholder: '(555) 555 - 5555',
    ssnFormatPlaceholder: '555-555-555',
    ssnTitle: 'Social Insurance Number',
    abbreviation: 'SIN',
    validation: {
      ssn: {
        value: /^\d{9}$/,
        message: 'Invalid SIN',
      },
    },
  },
  MX: {
    code: 'MX',
    code3: Country.MEX,
    aliases: ['mexico', 'mex', 'méxico'],
    label: 'Mexico',
    phoneCode: '+52',
    phoneFormatPlaceholder: '55-5555-5555',
    ssnFormatPlaceholder: '55555555555',
    ssnTitle: 'Número de Seguridad Social',
    abbreviation: 'NSS',
    validation: {
      ssn: {
        value: /^\d{11}$/,
        message: 'Invalid NSS',
      },
    },
  },
  // Add other countries here
}

export const standardizeCountry = (value: string): string => {
  const lower = value.toLowerCase().trim()
  const match = Object.values(CountryConfig).find((config) =>
    config.aliases.includes(lower)
  )
  return match ? match.code3 : value
}

export const findIssuingCountry = (
  issuingCountry: string
): CountryConfigItem | undefined => {
  return Object.values(CountryConfig).find(
    (config) => config.code === issuingCountry
  )
}
